<section class="change-password-page" *ngIf="loginForm">
  <header class="change-password-header">
    <div>
      <span class="change-password-kicker">{{t?.usuario}}</span>
      <h1>{{t?.cambiarclave}}</h1>
      <p>{{t?.changepassSubtitulo}}</p>
    </div>
  </header>

  <div class="change-password-layout">
    <form [formGroup]="loginForm" (submit)="onSubmit()" class="change-password-form">
      <div class="change-password-form-title">
        <span class="change-password-title-icon">
          <i class="fa fa-shield-alt"></i>
        </span>
        <div>
          <h2>{{t?.changepassFormularioTitulo}}</h2>
          <p>{{t?.changepassFormularioTexto}}</p>
        </div>
      </div>

      <div class="change-password-fields">
        <label class="change-password-field" for="passwordactual">
          <span>{{t?.changepassClaveActual}}</span>
          <span class="change-password-input">
            <i class="fa fa-lock"></i>
            <input
              type="password"
              id="passwordactual"
              class="form-control"
              formControlName="passwordactual"
              [placeholder]="t?.changepassClaveActualPlaceholder"
            >
          </span>
        </label>

        <label class="change-password-field" for="passwordnueva">
          <span>{{t?.changepassClaveNueva}}</span>
          <span class="change-password-input">
            <i class="fa fa-key"></i>
            <input
              type="password"
              id="passwordnueva"
              class="form-control"
              formControlName="passwordnueva"
              [placeholder]="t?.changepassClaveNuevaPlaceholder"
            >
          </span>
        </label>

        <label class="change-password-field" for="passwordnueva2">
          <span>{{t?.changepassRepetirClaveNueva}}</span>
          <span class="change-password-input">
            <i class="fa fa-check-circle"></i>
            <input
              type="password"
              id="passwordnueva2"
              class="form-control"
              formControlName="passwordnueva2"
              [placeholder]="t?.changepassRepetirClaveNuevaPlaceholder"
            >
          </span>
        </label>

        <div
          class="change-password-match"
          [class.change-password-match-error]="loginForm.errors?.nocoinciden"
          *ngIf="loginForm.get('passwordnueva')?.value || loginForm.get('passwordnueva2')?.value"
        >
          <i class="fa" [ngClass]="loginForm.errors?.nocoinciden ? 'fa-exclamation-circle' : 'fa-check-circle'"></i>
          <span>
            {{loginForm.errors?.nocoinciden
              ? t?.changepassNoCoinciden
              : t?.changepassCoinciden}}
          </span>
        </div>
      </div>

      <div class="change-password-actions">
        <button type="submit" class="change-password-submit" [disabled]="!loginForm.valid">
          <span>{{t?.cambiarclave}}</span>
          <span class="change-password-submit-icon" aria-hidden="true">
            <i class="fa fa-arrow-right"></i>
          </span>
        </button>
      </div>
    </form>

    <aside class="change-password-guidance">
      <span class="change-password-guidance-icon">
        <i class="fa fa-user-shield"></i>
      </span>
      <h2>{{t?.changepassConsejosTitulo}}</h2>
      <ul>
        <li>
          <i class="fa fa-check"></i>
          <span>{{t?.changepassConsejoUno}}</span>
        </li>
        <li>
          <i class="fa fa-check"></i>
          <span>{{t?.changepassConsejoDos}}</span>
        </li>
        <li>
          <i class="fa fa-check"></i>
          <span>{{t?.changepassConsejoTres}}</span>
        </li>
      </ul>
    </aside>
  </div>
</section>
